export default __webpack_public_path__ + "static/media/b2-med.229d59c5.jpg";